import { AuthFetchWithResponse } from 'src/Types/api'
import { ApiResult } from 'src/Libs/api'
import { StatusCodes } from 'src/Libs/http-status-codes'
import { AuthFetchError } from '@e3dc-react/shell/Types/api'
import { handleFetchError } from 'src/Libs/api/utils'
import { VehicleInformationModel } from '../models'

interface StartReauthenticationResponseDto {
  url: string
}

/**
 * Start reauthentication process for a user vehicle that is disconnected
 * @returns re-authentication URL to redirect the EHA login page
 */
export const startReauthenticateVehicle = async (
  vehicleId: VehicleInformationModel['id'],
  installationId: string,
  authFetch: AuthFetchWithResponse
): Promise<ApiResult<string, AuthFetchError | Error>> => {
  try {
    const response = await authFetch<StartReauthenticationResponseDto>({
      path: `vehicles/installations/${installationId}/vehicles/${vehicleId}/reauth`,
      method: 'POST',
      payload: {},
      endpoint: process.env.REACT_APP_VEHICLES_ENDPOINT,
    })

    if (response.status === StatusCodes.OK) {
      const loginUrl = response.data.url
      return new ApiResult<string, Error | AuthFetchError>(loginUrl)
    }

    return new ApiResult<string, Error | AuthFetchError>(null, true)
  } catch (error) {
    return handleFetchError<string>(error)
  }
}

/**
 * apply re-authentication settings for a user vehicle that is disconnected
 */
export const applyReauthenticateVehicle = async (
  vehicleId: string,
  installationId: string,
  vendorAccountId: string,
  authFetch: AuthFetchWithResponse
): Promise<ApiResult<boolean, AuthFetchError | Error>> => {
  try {
    /* we don't need the response data, hence type unknown */
    const response = await authFetch<unknown>({
      path: `vehicles/installations/${installationId}/vehicles/${vehicleId}/reauth/${vendorAccountId}`,
      method: 'POST',
      payload: {},
      endpoint: process.env.REACT_APP_VEHICLES_ENDPOINT,
    })

    if (response.status === StatusCodes.OK) {
      return new ApiResult<boolean, Error | AuthFetchError>(true)
    }

    return new ApiResult<boolean, Error | AuthFetchError>(null, true)
  } catch (error) {
    return handleFetchError<boolean>(error)
  }
}
